import React from "react";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import SEO from "../components/shared/SEO";
import AuthCard from "../components/shared/AuthCard";
import BlogWriteDesktopOnly from "../components/blog/BlogWriteDesktopOnly";

export default function WriteBlog() {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-white pt-16">
      <SEO
        title="Write a Blog | SoloConnect"
        description="Login or create an account to write blogs, share tips and inspire travelers on SoloConnect."
        keywords="write blog, login, sign up, solo travel blog, SoloConnect"
      />
      <Newnabar />

      <main className=" ">
        <div className="hidden md:block">
          <AuthCard />
        </div>
        <div className="block md:hidden">
          <BlogWriteDesktopOnly />
        </div>
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>
      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
